var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      staticStyle: { "max-height": "400px", "overflow-y": "auto" },
      attrs: { width: "400", trigger: "click" },
    },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 11 } }, [
            _c("div", { staticClass: "ellip" }, [
              _vm._v(_vm._s(_vm.sourceLinkageInfo.targetViewName)),
            ]),
          ]),
          _c("el-col", { attrs: { span: 11 } }, [
            _c("div", { staticClass: "ellip" }, [
              _vm._v(_vm._s(_vm.linkageInfo.targetViewName)),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { height: "120px", "overflow-y": "auto" } },
        _vm._l(_vm.linkageInfo.linkageFields, function (itemLinkage, index) {
          return _c(
            "el-row",
            { key: index },
            [
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "div",
                  { staticClass: "select-filed" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", placeholder: "请选择" },
                        model: {
                          value: itemLinkage.sourceField,
                          callback: function ($$v) {
                            _vm.$set(itemLinkage, "sourceField", $$v)
                          },
                          expression: "itemLinkage.sourceField",
                        },
                      },
                      _vm._l(
                        _vm.sourceLinkageInfo.targetViewFields,
                        function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "div",
                  { staticClass: "select-filed" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", placeholder: "请选择" },
                        model: {
                          value: itemLinkage.targetField,
                          callback: function ($$v) {
                            _vm.$set(itemLinkage, "targetField", $$v)
                          },
                          expression: "itemLinkage.targetField",
                        },
                      },
                      _vm._l(_vm.linkageInfo.targetViewFields, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { float: "left" } },
                              [
                                item.deType === 0
                                  ? _c("svg-icon", {
                                      staticClass: "field-icon-text",
                                      attrs: { "icon-class": "field_text" },
                                    })
                                  : _vm._e(),
                                item.deType === 1
                                  ? _c("svg-icon", {
                                      staticClass: "field-icon-time",
                                      attrs: { "icon-class": "field_time" },
                                    })
                                  : _vm._e(),
                                item.deType === 2 || item.deType === 3
                                  ? _c("svg-icon", {
                                      staticClass: "field-icon-value",
                                      attrs: { "icon-class": "field_value" },
                                    })
                                  : _vm._e(),
                                item.deType === 5
                                  ? _c("svg-icon", {
                                      staticClass: "field-icon-location",
                                      attrs: { "icon-class": "field_location" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  color: "#8492a6",
                                  "font-size": "12px",
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 2 } }, [
                _c(
                  "div",
                  [
                    _c("el-button", {
                      staticStyle: { float: "left" },
                      attrs: {
                        icon: "el-icon-delete",
                        type: "text",
                        size: "small",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteLinkageField(index)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { staticClass: "bottom" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: "success",
                icon: "el-icon-plus",
                round: "",
              },
              on: {
                click: function ($event) {
                  return _vm.addLinkageField(null, null)
                },
              },
            },
            [_vm._v("追加联动依赖字段")]
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "icon iconfont icon-edit slot-class",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }